import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import env from '@frontend/env';
import { IpcShellProvider } from '@frontend/shell-utils';
import { requestUserPreferencesSync } from '@frontend/user-preferences';
import { ThemeProvider } from '@frontend/design-system';
import { App } from './app';
import { ErrorBoundary } from './components/error-boundary';
import { DebugModeProvider } from './providers/debug-provider';
import { NotificationManagerProvider } from './providers/notification-manager';

requestUserPreferencesSync();

const Root = () => {
  console.log('Version: - ', env.VERSION);
  return (
    <SentryErrorBoundary
      fallback={() => {
        window.location.reload();
        return <>An Error Occurred</>;
      }}
    >
      <IpcShellProvider context='notifications'>
        <ThemeProvider includeEmotionTheme skipAnimation={false}>
          <ErrorBoundary>
            <DebugModeProvider>
              <NotificationManagerProvider>
                <App />
              </NotificationManagerProvider>
            </DebugModeProvider>
          </ErrorBoundary>
        </ThemeProvider>
      </IpcShellProvider>
    </SentryErrorBoundary>
  );
};

export default Root;
